import { WithPopover, Wrapper } from '@american-autonomy/ag-ui';

import DropdownMenuItemContainer from 'components/DropdownMenuItemContainer';
import WithArrow from 'components/WithArrow';
import BodyText from 'components/text/BodyText';

import useExportKml from './hooks/useExportKml';
import useExportPdf from './hooks/useExportPdf';
import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ExportDropdown: FunctionComponent<Props> = ({
    className = '',
    selectedFlights = [],
    testId = TEST_ID
}) => {
    const { EXPORT, EXPORT_KML, EXPORT_PDF } = useTranslation();
    const { handleExportKml } = useExportKml({ selectedFlights });
    const { handleExportPdf } = useExportPdf({ selectedFlights });
    const isDisabled = selectedFlights.length === 0;
    const disabledClass = isDisabled ? styles.triggerDisabled : '';
    const trigger = (
        <WithArrow className={`${styles.trigger} ${disabledClass}`}>
            <BodyText text={EXPORT} />
        </WithArrow>
    );

    if (isDisabled) {
        return (
            <Wrapper className={`${className} ${styles.exportDropdown}`} testId={testId}>
                {trigger}
            </Wrapper>
        );
    }

    return (
        <WithPopover
            className={`${className} ${styles.exportDropdown}`}
            direction='bottomLeft'
            testId={testId}
            trigger={trigger}>
            <Wrapper className={styles.menu}>
                <DropdownMenuItemContainer onClick={handleExportPdf}>
                    <BodyText className={styles.menuItemText} text={EXPORT_PDF} />
                </DropdownMenuItemContainer>

                <DropdownMenuItemContainer onClick={handleExportKml}>
                    <BodyText className={styles.menuItemText} text={EXPORT_KML} />
                </DropdownMenuItemContainer>
            </Wrapper>
        </WithPopover>
    );
};

export default ExportDropdown;
